import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useBrandGroupMember from '@hooks/useBrandGroupMember'
import useBrandGroupMembers from '@hooks/useBrandGroupMembers'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import type { BrandGroupMemberModel } from '@models/types'

import BrandGroupMemberListItem from './BrandGroupMemberListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Member Title',
    },
  ]
}

const BrandGroupMembers = (props: { brandGroupId: number }) => {
  const { brandGroupId } = props

  const filterPayload = useFilters()
  const { pageFilters } = filterPayload

  const brandGroupMemberPayload = useBrandGroupMember({ brand_group_id: brandGroupId })
  const {
    callbacks: {
      addBrandGroupMembers,
    },
  } = brandGroupMemberPayload

  const brandGroupMembersPayload = useBrandGroupMembers({
    filters: {
      brand_group_id: brandGroupId,
      ...pageFilters,
    },
    performHttpRequests: !!brandGroupId,
    requestOptions: { include_member_details: true },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredBrandGroupMembers,
    filteredBrandGroupMembersCount,
    hasFilteredBrandGroupMembers,
    loading,
  } = brandGroupMembersPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={hasFilteredBrandGroupMembers && <DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Members"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && !hasFilteredBrandGroupMembers && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Members present.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please adjust your filters or add a Member.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasFilteredBrandGroupMembers && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection flexDirection="column" maxHeight={600}>
          {filteredBrandGroupMembers.map((brandGroupMember: BrandGroupMemberModel) => (
            <BrandGroupMemberListItem
              key={brandGroupMember.id}
              brandGroupMember={brandGroupMember}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredBrandGroupMembersCount}
        loading={loading}
      >
        <Button
          buttonStyle="secondaryEdit"
          icon={<FontAwesomeIcon icon={faPlus} />}
          onClick={() => addBrandGroupMembers()}
          // @ts-expect-error TS2322
          size={['medium', 'small']}
          width={['100%', 'fit-content']}
        >
          Add Member
        </Button>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default BrandGroupMembers
